export class WbSocialShare {
  constructor() {}

  init() {
    const _this = this;

    return new Promise((resolve) => {
      _this.bindListeners();
      resolve();
    });
  }

  bindListeners() {
    const _this = this;

    document
      .querySelectorAll('.wb-social-share__copy-link')
      .forEach((btn) => (btn.onclick = _this.copyLink.bind(_this)));
    document
      .querySelectorAll('.wb-social-share__toggle')
      .forEach((btn) => (btn.onclick = _this.toggleVisibility.bind(_this)));
  }

  copyLink(e) {
    const target = e.currentTarget;
    const temp = document.createElement('input');
    const copied = target.querySelector('.wb-social-share__copy-link__copied');
    const dataLink = target.dataset.link;

    document.querySelector('body').appendChild(temp);

    temp.value = dataLink || window.location.href;
    temp.select();
    document.execCommand('copy');
    temp.remove();

    copied._show();
    setTimeout(() => {
      copied._hide();
    }, 1000);
  }

  toggleVisibility(e) {
    const target = e.currentTarget;
    const controlled = target.getAttribute('aria-controls');

    target._toggleAriaExpanded();
    document.querySelector(`#${controlled}`)._toggle();
  }
}
